module.exports = __webpack_public_path__ + "img/206-6c0a5c.png";